<template>
  <div id="topic" v-if="label_info">
    <Cutscenes v-if="showCutscenes"></Cutscenes>
    <DownloadNav :ifShow="ifShow"></DownloadNav>

    <!-- <download-nav></download-nav> -->

    <div class="tag-info">
      <div class="background" :style="`background-image:url(${label_info.label_cover})`"></div>
      <div class="business-tag" v-if="label_info.brand && Object.keys(label_info.brand).length > 0 ">
        <div class="shop-info">
          <img :src="label_info.label_icon" alt="" class="shop-logo">
          <span class="shop-name">{{label_info.label_name}}</span>
        </div>
        <div class="shop-detail">
          {{label_info.brand.brand_desc }}
        </div>
        <div class="comments-count">讨论 {{label_info.thread_count}}</div>
      </div>
      <div class="normal-tag" v-else>
        <div class="tag">
          <span class="tag-icon"></span>
          <span class="tag-name">{{label_info.label_name}}</span>
        </div>
        <div class="comments-count">讨论 {{label_info.thread_count}}</div>
      </div>
    </div>

    <div class="tab_content" id="tab_content">
      <div class="map-info" @click="toMap(label_info.location.latitude, label_info.location.longitude)" v-if="label_info.location && Object.keys(label_info.location).length > 0">
        <div class="address">
          <span>地址：</span>
          <span>{{label_info.location.location_detail}}</span>
        </div>

        <span class="map-icon"></span>
      </div>
      <div class="water_fall">
        <div class="col_wrap">
          <div ref="col_0">
            <div v-for="(item,index) in waterFall.col_0" class="item" :key="index" @click="jumpPoDetail(item.id)">
              <div class="read_count">{{item.views}}</div>
              <div class="img" :style="`background-image:url(${item.cover.hd_url});background-size: cover;background-position: center;background-repeat: no-repeat;height:${item.cover.h}px;width:${item.cover.w}px;`">
                <div class="mask" v-if="item.type == 2">
                  <div class="video-btn"></div>
                </div>
              </div>
              <p class="desc" v-html="item.content"></p>
              <div class="user_n_time">
                <div class="user-info">
                  <img :src="item.user.face" class="user_avatar" alt="">
                  <span :class="'username sex_'+item.user.gender">{{item.user.username}}</span>
                </div>

                <div class="praise-content">
                  <span class="praise-icon"></span>
                  <span>{{item.praise_count}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col_wrap">
          <div ref="col_1">
            <div v-for="(item,index) in waterFall.col_1" class="item" :key="index" @click="jumpPoDetail(item.id)">
              <div class="read_count">{{item.views}}</div>
              <div class="img" :style="`background-image:url(${item.cover.hd_url});background-size: cover;background-position: center;background-repeat: no-repeat;height:${item.cover.h}px;width:${item.cover.w}px;`">
                <div class="mask" v-if="item.type == 2">
                  <div class="video-btn"></div>
                </div>
              </div>
              <p class="desc" v-html="item.content"></p>
              <div class="user_n_time">
                <div class="user-info">
                  <img :src="item.user.face" class="user_avatar" alt="">
                  <span :class="'username sex_'+item.user.gender">{{item.user.username}}</span>
                </div>

                <div class="praise-content">
                  <span class="praise-icon"></span>
                  <span>{{item.praise_count}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="upload-tips" @click="openApp(noMoreData)">{{!noMoreData ?( loading ? '正在加载中' : '上拉加载更多哦') : '啊哦加载完了，打开app查看更多有趣的话题吧' }}~</p>

    </div>
  </div>

</template>
<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
@import "./tagList.scss";
</style>

<script>
import DownloadNav from "@/components/download_tab/DownloadNav.vue";
import TabNav from "@/components/tab_nav/TabNav.vue";
import BottomLoading from "@/components/bottom_loading/BottomLoading.vue";
import PicBox from "@/components/pic_box/PicBox.vue";
import Cutscenes from "@/components/cutscenes/Cutscenes.vue";
import Vue from "vue";
import qs from "qs";
import { getParams, magicLink } from "@/untils/until.js";
export default {
  name: "app",
  data() {
    return {
      showCutscenes: true,
      tabsConfig: {
        tabs: [],
        active: 1
      },
      // 当前选项卡选中的类型
      curTabType: "",
      loading: false,
      topicMode: 0, // 0普通话题 其他高级话题
      listMode: 1, // 0普通模式 1瀑布流模式
      ifShowBottomLoading: false,
      allData: null,
      hotData: null,
      activity: null,
      tag_info: null,
      t: null,
      // 普通列表要展示的数据
      normalList: [],
      // 瀑布流列表要展示的数据
      waterFall: {
        col_0: [],
        col_1: [],
        // 高度较短的列的索引
        short: 0
      },
      openMap: false,
      // 最新
      newestList: [],
      newPage: 1,
      // 热门
      hotList: [],
      hotPage: 1,
      // 排行榜
      rankList: [],
      rankPage: 1,
      noMoreData: false,
      loaded: false,
      label_info: {},
      map: null,
      page: 1,
      ifShow: false
    };
  },

  components: {
    DownloadNav,
    TabNav,
    BottomLoading,
    PicBox,
    Cutscenes
  },
  methods: {
    toMap(lat, log) {
      window.location = `/webpo.php?map=1&lat=${lat}&log=${log}&title=${
        this.label_info.label_name
      }`;
    },

    // 渲染瀑布流
    renderWaterFall(data) {
      let self = this;
      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        let imgRatio = data[index].cover.h / data[index].cover.w;
        let imgW = w;
        let imgH = w * imgRatio;
        let item = data[index];
        item.cover.w = imgW;
        item.cover.h = imgH;
        self.waterFall["col_" + self.waterFall.short].push(item);
        Vue.nextTick(function() {
          let h0 = self.$refs.col_0.offsetHeight;
          let h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;
          if (index >= data.length) {
            return;
          }
          calcWaterFall(data);
        });
      }
    },
    // 跳转详情页
    jumpPoDetail(po_id) {
      this.$router.push("/newDetail/" + po_id);
    },

    openAppTopic() {
      magicLink('po_tag','tag_id='+ this.$route.params.tag_id)
    },
    formatSticker() {
      let potxt = document.getElementsByClassName("po_txt");

      let commentTxt = document.getElementsByClassName("comment_list");

      let waterFallContent = document.getElementsByClassName("desc");

      if (potxt.length) {
        let txtFontSize = Number.parseInt(
          window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        let commentFontSize = Number.parseInt(
          window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(commentTxt, commentFontSize);
      }
      if (waterFallContent.length) {
        let waterFallFontSize = Number.parseInt(
          window
            .getComputedStyle(waterFallContent[0], null)
            .fontSize.split("px")[0]
        );
        this.forCircle(waterFallContent, waterFallFontSize);
      }
    },
    forCircle(item, fontSize) {
      for (let i = 0, length = item.length; i < length; i++) {
        let img = item[i].querySelectorAll("img");
        if (img.length) {
          for (let j = 0, length = img.length; j < length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    },
    getData() {
      let api = "/index.php?r=web/labelinfo&v=4.7.0";
      let self = this;
      let obj = {
        params: {
          page: this.page || 1,
          label_id: this.$route.params.tid
        }
      };
      if (this.$route.query.from) {
        obj.params.from = this.$route.query.from;
      }
      if (this.$route.query.isappinstalled) {
        obj.params.isappinstalled = this.$route.query.isappinstalled;
      }
      let reqData = {
        data: JSON.stringify(obj)
      };
      if (this.loading == true) {
        return;
      }
      this.loading = true;
      this.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          if (resBody.ret == 0) {
            wx.ready(function() {
              wx.onMenuShareTimeline({
                title: resBody.data.label_info.share.share_title,
                link: resBody.data.label_info.share.share_url,
                imgUrl: resBody.data.label_info.share.share_image_url
              });
              wx.onMenuShareAppMessage({
                title: resBody.data.label_info.share.share_title,
                desc: "惠州生活必备-西子湖畔App",
                link: resBody.data.label_info.share.share_url,
                imgUrl: resBody.data.label_info.share.share_image_url
              });
            });
            this.showCutscenes = false;
            this.label_info = resBody.data.label_info;

            // 普通话题
            if (resBody.data.list.length > 0) {
              this.page = this.page + 1;
            }
            this.normalList = resBody.data.list;
            this.loading = false;
            // 渲染最热数据
            this.renderWaterFall(resBody.data.list);
          }
        });
    },
    getMoreData(page, cb) {
      let api = "/index.php?r=web/labelinfo&v=4.7.0";
      let self = this;
      let obj = {
        params: {
          page: page || 1,
          label_id: this.$route.params.tid
        }
      };
      if (this.$route.query.from) {
        obj.params.from = this.$route.query.from;
      }
      if (this.$route.query.isappinstalled) {
        obj.params.isappinstalled = this.$route.query.isappinstalled;
      }
      let reqData = {
        data: JSON.stringify(obj)
      };
      if (this.loading == true) {
        return;
      }
      this.loading = true;
      this.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          if (resBody.ret == 0) {
            cb && cb(resBody.data.list);
            this.loading = false;
          }
        });
    }
  },
  created() {
    // //加载首屏数据
    this.getData();
  },
  mounted() {
    let self = this;
    document.title = "标签";
        let oNav = document.querySelector(".download_nav");
    let h = oNav.offsetHeight;
    window.addEventListener("scroll", function(e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH && !self.loading) {
        self.getMoreData((self.page += 1), data => {
          if(data.length) {
            self.normalList = self.normalList.concat(data);
            self.renderWaterFall(self.normalList);
          }
        });
      }
      if (sTop > h) {
        self.ifShow = true;
      } else {
        self.ifShow = false;
      }
    });
  },
  updated() {
    this.formatSticker();
  }
};
</script>



// WEBPACK FOOTER //
// tagList.vue?26d1778e